import { Component, Inject, OnInit } from "@angular/core";
import { ShareService } from "../service/share.service";
import { kesariAnimations } from "../animation";
import { Meta, Title } from "@angular/platform-browser";
import { ActivatedRoute } from "@angular/router";
import { DOCUMENT } from "@angular/common";

@Component({
  selector: "app-memorable-section",
  templateUrl: "./memorable-section.component.html",
  styleUrls: ["./memorable-section.component.scss"],
  animations: kesariAnimations,
})
export class MemorableSectionComponent implements OnInit {
  active = 1;
  public isCollapsed = true;
  memoRable = [];
  domesticDestinations = [];
  internationalDestinations = [];
  internationalDataArray = [];
  domesticDataArray = [];
  metaData = {
    isProduct: false,
    page: "MICE-MEMORABLE"
  }
  constructor(
    private memorable: ShareService,
    private meta: Meta,
    private title: Title, 
    @Inject(DOCUMENT) private dom
  ) { }

  ngOnInit(): void {
    this.getDestination();
    // this.meta.addTags([
    //   { name: "description", content: "Memorable" },
    //   { name: "keywords", content: "kesari mice Memorable" },
    // ]);


  }
  getDestination() {
    this.memorable.getmiceDestination().subscribe((arg) => {
      // console.log(arg)
      const data = arg.data;
      const domesticData = data.filter((item) => item.ID === "D");
      const internationalData = data.filter((item) => item.ID === "I");

      this.domesticDestinations = domesticData;
      this.internationalDestinations = internationalData;
      //   console.log('Domes', this.domesticDestinations)
      //   console.log('Int', this.internationalDestinations)
      //   this.internationalDataArray = internationalData.flatMap(item => item.data);
      //  this.domesticDataArray = domesticData.flatMap(item=>item.data);

      // console.log(this.domesticDataArray);
    });
    
    // this.metaData.page=this.route._routerState.snapshot.url
    // this.route._routerState.snapshot.url.subscribe((params) => {
    //   debugger
    //   params})
    this.memorable.getMetaData(this.metaData).subscribe((data) => {
      // console.log(data)
      if(data.length !=0){
        this.meta.updateTag({ property: 'og:title', content: data[0].meta_title });
        this.meta.updateTag({ name: 'keywords', content: data[0].meta_keyword });
        this.meta.updateTag({ name: 'description', content: data[0].meta_description });
        this.title.setTitle(data[0].meta_title);
        // console.log(data[0].meta_description)
      } else {
        this.title.setTitle('Memorable');
        // this.meta.updateTag({name:'Author',content:'Memorable'})
        // this.meta.updateTag({name:'Publisher',content:'Memorable'})
      }
      
    })
    this.memorable.setCanonicalURL();
    // this.updateCanonicalUrl()
  }
  
  updateCanonicalUrl(){    
    let link: HTMLLinkElement = this.dom.createElement('link');
    link.setAttribute('rel', 'canonical');
    this.dom.head.appendChild(link);
    link.setAttribute('href', this.dom.URL);
    console.log(link.setAttribute('href', this.dom.URL))
  }
  
}
